// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import { Autocomplete } from 'stimulus-autocomplete'

import Flatpickr from 'stimulus-flatpickr'
import flatpickr from "flatpickr"
import { Portuguese } from "flatpickr/dist/l10n/pt.js"


flatpickr.localize(Portuguese)
flatpickr.setDefaults({dateFormat: 'd/m/Y'})

const application = Application.start()
const context = require.context("controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))

application.register('autocomplete', Autocomplete)
application.register('flatpickr', Flatpickr)

const initFlatpickr = () => {
  flatpickr(".datepicker", {
    locale: Portuguese,
    altInput: true,       // Cria o campo visual para o usuário
    altFormat: "d/m/Y",    // Usuário vê: 18/03/2026
    dateFormat: "Y-m-d",   // Rails recebe: 2026-03-18 (Formato ISO, sem erro)
    allowInput: true,
    // Garante que ao limpar o campo, o valor suma de verdade
    onReady: function(selectedDates, dateStr, instance) {
      if (instance.altInput) {
        instance.altInput.classList.add("form-control"); // Mantém seu estilo CSS
      }
    }
  });
}